import React from "react";
import RecordEditorModal from "@/appComponents/Blocks/Modals/RecordEditorModal/RecordEditorModal";
import { useTableManagerContext } from "@/providers/AppendTableProvider";
import { useChartSettingsContext } from "@/providers/ChartSettingsProvider";
import { enumObjectTypes } from "@coreapp/constants";
import { basicEmployeeEmployeeFields, basicEmployeePositionFields } from "./PlanRecordEditorModal";
import { IsPositionChart } from "@coreapp/utils/IsPositionChart";
import { GetMappedOptionalFields } from "@/appComponents/Blocks/Modals/SettingsModal/ChartSettings/MappingConfiguration/Utils";

export const AppendTableRecordEditorModal = () => {
  const {
    recordEditorContextValue: { theData, showRecordEditor, onSaveRecordEdit, onCloseRecordEditor },
    tableManager
  } = useTableManagerContext();

  const { chartConfigRef } = useChartSettingsContext();

  const recordData = theData[enumObjectTypes.holder];

  if (!showRecordEditor || !tableManager.state) return;

  let tableMgr = tableManager.state;

  const isPositionChart = IsPositionChart(chartConfigRef?.current);
  const baseFields = isPositionChart ? basicEmployeePositionFields : basicEmployeeEmployeeFields;
  const mappedOptionalFields = GetMappedOptionalFields(chartConfigRef?.current, baseFields);
  const basicFields = [...baseFields, ...mappedOptionalFields];

  const cloneOverride = tableManager.state.CloneDeltas(recordData.override);

  const currentChartConfig = { ...chartConfigRef.current };
  const queryChartId = chartConfigRef.current?.ID || null;

  return (
    <RecordEditorModal
      showCommentsTab
      allowOrphans={true}
      dataTestIdPrefix="append-table-record-editor-"
      show={showRecordEditor}
      manager={tableManager.state}
      overrideObj={recordData.override}
      cloneOverride={cloneOverride}
      dbObj={recordData.dataObj}
      type={recordData.type}
      basicFields={basicFields}
      additionalFields={tableMgr.GetAvailableChartFields(currentChartConfig)}
      manualFields={tableMgr.GetManualAddedFields(currentChartConfig)}
      chartConfig={currentChartConfig}
      showAdditionalReportsTab={!isPositionChart}
      onSave={onSaveRecordEdit}
      onClose={onCloseRecordEditor}
      otherHeaderProps={{ modifier: "grey" }}
      overlayProps={{
        showOverlay: true
      }}
      queryChartId={queryChartId}
    />
  );
};
